import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    /* {
      path: "/",
      name: "Login",
      component: () => import("@/components/LoadingPage.vue"),
    }, */
    {
      path: "/docs",
      name: "Documentations",
      component: () => import("@/pages/Documentations.vue")
    },
    {
      path: "/",
      name: "PostCodeSearch",
      component: () => import("@/pages/MainPage.vue"),
    },
    {
      path: "/media",
      name: "Media",
      component: () => import("@/pages/Media.vue"),
    },
    {
      path: "/terms",
      name: "Terms",
      component: () => import("@/pages/Terms.vue"),
    },
    
    {
      path: "/404",
      name: "404",
      component: () => import("@/components/error/404.vue"),
    },
    {
      path: "*",
      name: "UnknownPage",
      component: () => import("@/components/error/404.vue"),
    },
  ],
});
export default router;
